function hideProcessing() {
    var $subscribe = $('.editors-choice-subscription .loader');

    if ($subscribe.length === 0) {
        return;
    }

    $subscribe.removeClass('processing');
    $subscribe.hide();
}

function hideAllLinks() {
    var $allLinks = $('.editors-choice-subscription .ec-subscribtion-link');
    $allLinks.removeClass('active');
}
function hideSubscriptionErrors() {
    var $error = $('.editors-choice-subscription .error');
    $error.html('');
    $error.hide();

    hideProcessing();
}
function showProcessing() {
    var $subscribe = $('.editors-choice-subscription .loader');

    if ($subscribe.length === 0) {
        return;
    }

    $subscribe.addClass('processing');
    $subscribe.show();

    hideAllLinks();
}
function showSubscriptionError(errorMsg) {
    var $error = $('.editors-choice-subscription .error');

    $error.html(errorMsg);
    $error.show();

    hideProcessing();
}

function showLinK(linkClassName) {
    var $linkToShow = $('.editors-choice-subscription .' + linkClassName);
    $linkToShow.addClass('active');
}

function initLinksOnClickEvents() {
    var $manageAlert = $('.editors-choice-subscription .manage-alert-settings');
    var $subscribe = $('.editors-choice-subscription .subscribe-to-ec-alert');
    var $unsubscribe = $('.editors-choice-subscription .unsubscribe-from-alert');
    var $loginButton = $('#loginButton');
    //var $youAreSubscribed = $('.editors-choice-subscription .you-are-subscribed');
    //var $youHaveUnsubscribed = $('.editors-choice-subscription .you-have-unsubscribed');

    $manageAlert.off('click');
    $subscribe.off('click');
    $unsubscribe.off('click');

    $manageAlert.on('click', function () {
        window.location.hash = window.location.hash + '#subscribe-to-ec-alert';

        if ($loginButton.length > 0) {
            $loginButton.trigger('click');
            return false;
        }
    });

    $subscribe.on('click', function (event) {
        var failureMsg = "Failed to subscribe to Editors' Choice E-alert.";
        var jsonResult;
        showProcessing();

        $.ajax({
            url: '/pb/widgets/editorsChoiceAlertsController/subscribe',
            method: 'GET',
            error: function (xhr) {
                showSubscriptionError(failureMsg);
            },
            success: function (data) {
                if (data === '') {
                    showSubscriptionError(failureMsg);
                    return false;
                }

                jsonResult = jQuery.parseJSON(data);

                if (jsonResult.status === 'Error') {
                    showSubscriptionError(jsonResult.errorMsg);
                    return false;
                }

                hideAllLinks();
                showLinK('you-are-subscribed');

                hideSubscriptionErrors();
                hideProcessing();
            },
        });

        event.preventDefault();
    });

    $unsubscribe.on('click', function (event) {
        var failureMsg = "Failed to unsubscribe from Editors' Choice E-alert.";
        var jsonResult;

        showProcessing();

        $.ajax({
            url: '/pb/widgets/editorsChoiceAlertsController/unsubscribe',
            method: 'GET',
            error: function (xhr) {
                showSubscriptionError(failureMsg);
            },
            success: function (data) {
                if (data === '') {
                    showSubscriptionError(failureMsg);
                    return false;
                }

                jsonResult = jQuery.parseJSON(data);

                if (jsonResult.status === 'Error') {
                    showSubscriptionError(jsonResult.errorMsg);
                    return false;
                }

                hideAllLinks();
                showLinK('you-have-unsubscribed');

                hideSubscriptionErrors();
                hideProcessing();
            },
        });

        event.preventDefault();
    });
}

function initEditorsChoiceAlertSubscriptionWidget() {
    var $container = $('.editors-choice-subscription');
    var $userId, userIdValue, $manageAlerts;

    if ($container.length === 0) {
        return;
    }

    $userId = $container.find('.user-id');
    userIdValue = $userId.val();

    if (userIdValue === -1) {
        $manageAlerts = $container.find('.manage-alert-settings');
        $manageAlerts.addClass('active');
    }

    initLinksOnClickEvents();
}
/*
function subscribeToEditorsChoiceAlert() {
    var $subscribe = $('.editors-choice-subscription .subscribe-to-ec-alert');

    if ($subscribe.length === 0) {
        return;
    }

    $subscribe.trigger('click');
}
*/

$(document).ready(initEditorsChoiceAlertSubscriptionWidget);

if (window.PB && window.PB.$) {
    window.PB.$(document.documentElement).on(
        'ScopeModified ScopeLoaded WidgetReloaded',
        initEditorsChoiceAlertSubscriptionWidget
    );
}
